import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';

export const useEntityListCardStyles = makeStyles(
  (theme: Theme) => {
    return {
      entityCard: {
        borderRadius: '.75rem',
        padding: '1rem',
        backgroundColor: theme.palette.mode === 'dark' ? '#474747' : '#FFF',
        display: 'flex',
        border: theme.palette.mode === 'dark' ? 'none' : '1px solid #E9EBEC',
        flexDirection: 'column',
        height: '100%',
        gap: '1rem',
      },
    };
  },
  { name: 'EntityListCard' },
);
